import { ProjectDetailsData } from '../interface/Photos.interface';

//Photo Type Helper
export const getDocStoreTypeName = (type?: null | string) => {
  let response = null;
  if (type === 'INTERNAL') {
    response = 'Internal Photo';
  } else if (type === 'SOURCE') {
    response = 'Send to Source';
  } else if (type === 'COMPLETE') {
    response = 'Complete';
  } else if (type === 'NEEDS_REVIEW') {
    response = 'Needs Review';
  }
  return response;
};
//ToolTilContent
export const handleTooltipContent = (value: {
  docCreatedBy?: string;
  docCreatedDate?: string;
}) => {
  const truncatedCreatedBy =
    value?.docCreatedBy && value?.docCreatedBy?.length > 150
      ? `${value?.docCreatedBy?.split(' ')?.slice(0, 15)?.join(' ')} |||`
      : value?.docCreatedBy;

  const content = `${truncatedCreatedBy} (${value?.docCreatedDate})`;

  return content;
};

//
export const showIsLeadRequiredAlertLowes = (
  projectDetailsData?: ProjectDetailsData
) => {
  if (
    (projectDetailsData?.epa_lead_assessment_required === 1 ||
      projectDetailsData?.epa_lead_remediation === 1) &&
    projectDetailsData?.project_lead_response_reason === null
  ) {
    return true;
  } else {
    return false;
  }
};

export const showIsLeadRequiredAlertHD = (
  projectDetailsData?: ProjectDetailsData
) => {
  if (
    (projectDetailsData?.epa_lead_assessment_required === 1 ||
      projectDetailsData?.epa_lead_remediation === 1) &&
    projectDetailsData?.epa_override_reason_code_id === null
  ) {
    return true;
  } else {
    return false;
  }
};

export const checkFileType = (
  files: FileList | File[],
  checkMediaType: string
) => {
  const fileArray = Array.from(files);
  let isValid = true;
  let errorMessage = '';

  const validImageTypes = ['image/png', 'image/jpeg'];
  const validVideoTypePrefix = 'video/';

  const isAllImages = fileArray?.every(file =>
    validImageTypes?.includes(file?.type)
  );
  const isAllVideos = fileArray?.every(file =>
    file?.type?.startsWith(validVideoTypePrefix)
  );
  if (!isAllImages && !isAllVideos) {
    isValid = false;
    errorMessage =
      'Please select either up to 5 image files (.png, .jpg) or a single video file, not both together.';
  }

  if (checkMediaType === 'Photo') {
    if (!isAllImages) {
      isValid = false;
      errorMessage = 'Only PNG or JPG photo files are allowed.';
    } else if (fileArray?.length > 5) {
      isValid = false;
      errorMessage = 'Please select up to 5 image files only at a time.';
    } else {
      for (const file of fileArray) {
        const fileExtension = file?.name?.split('.')?.pop()?.toLowerCase();
        if (fileExtension === 'svg') {
          isValid = false;
          errorMessage = 'System does not accept SVG files.';
          break;
        }
      }
    }
  }

  if (checkMediaType === 'Video') {
    if (!isAllVideos) {
      isValid = false;
      errorMessage = 'Only video files are allowed.';
    } else if (fileArray?.length > 1) {
      isValid = false;
      errorMessage = 'Please select only one video file at a time.';
    }
  }

  return { isValid, errorMessage };
};

export function findFileByOriginalName(
  files: File[] | undefined,
  originalFileName: string | undefined
): File | undefined {
  if (!Array.isArray(files) || !originalFileName) return undefined;

  return files?.find(file => file?.name === originalFileName);
}
